"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ControlPoint_1 = require("../editor/shapes/ControlPoint");
var planimetry_1 = require("../planimetry");
var SelectAbleShape_1 = require("./SelectAbleShape");
var Shape_1 = require("./Shape");
var R_1 = require("../R");
var ModifyKind;
(function (ModifyKind) {
    ModifyKind[ModifyKind["MoveAndModifyControlPoint"] = 0] = "MoveAndModifyControlPoint";
    ModifyKind[ModifyKind["Zoom"] = 1] = "Zoom";
})(ModifyKind = exports.ModifyKind || (exports.ModifyKind = {}));
/**
 * 可编辑图形
 */
var ModifyAbleShape = /** @class */ (function (_super) {
    __extends(ModifyAbleShape, _super);
    function ModifyAbleShape() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.controlPoints = [];
        // 默认认为用户选中图形是为了改变控制点和移动
        _this.kind = ModifyKind.MoveAndModifyControlPoint;
        _this.cleanEvent = function () { };
        _this.ZKeyDown = function (ev) {
            if (ev.keyCode === 90) { // z
                _this.cleanEvent();
                _this.engine.render(true);
                if (_this.kind === ModifyKind.MoveAndModifyControlPoint) {
                    // window.addEventListener('keydown', this.ZKeyDown);
                    _this.kind = ModifyKind.Zoom;
                    _this.modifyTransform();
                }
                else {
                    // window.addEventListener('keydown', this.ZKeyDown);
                    _this.kind = ModifyKind.MoveAndModifyControlPoint;
                    _this.modifyValue();
                }
            }
        };
        return _this;
    }
    ModifyAbleShape.prototype.onUnSelected = function () {
        this.controlPoints.forEach(function (shape) { return shape.remove(); });
        this.controlPoints = [];
    };
    ModifyAbleShape.prototype.modifyValue = function () {
        var _this = this;
        var newViewPort = this.engine.viewPort;
        this.controlPoints = ControlPoint_1.ControlPoint.genControlPoint(this.valueOf());
        newViewPort.engine.addSome(this.controlPoints);
        var lp = null; // 上一次点击的点
        var cp = null; // 点击到的控制点
        var mousedown = function (ev) {
            var _a = newViewPort.engine.ctx.canvas, offsetTop = _a.offsetTop, offsetLeft = _a.offsetLeft;
            var _b = __read([ev.offsetX - offsetLeft, ev.offsetY - offsetTop], 2), x = _b[0], y = _b[1];
            var vev = newViewPort.transformEvent('move', [x, y]);
            var result = newViewPort.engine.hitTest(vev.p);
            if (result.length !== 0) {
                lp = [x, y]; // 记录本次点击
                var shape = result.map(function (zi) { return newViewPort.engine.getShape(zi); });
                var cps = shape.filter(function (item) { return item instanceof ControlPoint_1.ControlPoint; });
                if (cps.length) {
                    cp = cps[0];
                }
            }
        };
        var mousemoveHandler = function (ev) {
            if (lp === null) {
                return;
            }
            var _a = newViewPort.engine.ctx.canvas, offsetTop = _a.offsetTop, offsetLeft = _a.offsetLeft;
            var _b = __read([ev.offsetX - offsetLeft, ev.offsetY - offsetTop], 2), x = _b[0], y = _b[1];
            if (cp === null) { // 移动
                var _c = __read([lp[0] - x, lp[1] - y], 2), dx_1 = _c[0], dy_1 = _c[1];
                var newValue = _this.valueOf().map(function (point) { return ([point[0] - dx_1, point[1] - dy_1]); });
                _this.setValue(newValue);
                _this.controlPoints.forEach(function (shape) { return shape.remove(); });
                _this.controlPoints = ControlPoint_1.ControlPoint.genControlPoint(_this.valueOf());
                newViewPort.engine.addSome(_this.controlPoints);
                newViewPort.engine.render(true);
                lp = [x, y];
            }
            else { // 修改控制点位置
                var _d = __read([lp[0] - x, lp[1] - y], 2), dx = _d[0], dy = _d[1];
                var _e = __read(cp.rectPos, 2), ox = _e[0], oy = _e[1];
                cp.setXY(ox - dx, oy - dy);
                var newValues = _this.valueOf();
                newValues[cp.pathIndex] = [ox - dx, oy - dy];
                _this.setValue(newValues);
                newViewPort.engine.render(true);
                lp = [x, y];
            }
        };
        var clean = function () {
            lp = null;
            cp = null;
        };
        newViewPort.engine.ctx.canvas.addEventListener('mousedown', mousedown);
        newViewPort.engine.ctx.canvas.addEventListener('mousemove', mousemoveHandler);
        newViewPort.engine.ctx.canvas.addEventListener('mouseup', clean);
        newViewPort.engine.ctx.canvas.addEventListener('mouseleave', clean);
        // 覆盖清除事件的方法
        this.cleanEvent = function () {
            clean();
            newViewPort.engine.ctx.canvas.removeEventListener('mousedown', mousedown);
            newViewPort.engine.ctx.canvas.removeEventListener('mousemove', mousemoveHandler);
            newViewPort.engine.ctx.canvas.removeEventListener('mouseup', clean);
            newViewPort.engine.ctx.canvas.removeEventListener('mouseleave', clean);
        };
        window.addEventListener('keydown', this.ZKeyDown);
    };
    ModifyAbleShape.prototype.modifyTransform = function () {
        var line = new Shape_1.Shape(); // 控制线
        this.controlPoints.forEach(function (shape) { return shape.remove(); });
        var padding = 10;
        var _a = __read(planimetry_1.getPointsRect(this.valueOf()), 4), x = _a[0], y = _a[1], w = _a[2], h = _a[3];
        var pointX = ControlPoint_1.ControlPoint.createPoint(x + w, y - padding, 0); // 横向控制点
        var pointY = ControlPoint_1.ControlPoint.createPoint(x - padding, y + h, 0); // 纵向控制点
        var pointRotate = ControlPoint_1.ControlPoint.createPoint(x + w + padding, y + h + padding, 0); // 旋转向控制点
        line.setValue([
            [x + w, y - padding],
            [x - padding, y - padding],
            [x - padding, y + h]
        ]);
        line.render = function (ctx) {
            return R_1.putPath(this.valueOf(), false)(ctx);
        };
        this.engine.addSome([line, pointX, pointY, pointRotate]);
        this.engine.render(true);
        console.log('modifyTransform');
    };
    ModifyAbleShape.prototype.onSelected = function (newViewPort, e) {
        if (this.kind === ModifyKind.MoveAndModifyControlPoint) {
            this.modifyValue();
        }
        else if (this.kind === ModifyKind.Zoom) {
            this.modifyTransform();
        }
    };
    /**
     * 取消选中
     */
    ModifyAbleShape.prototype.unSelect = function () {
        this.controlPoints.forEach(function (shape) { return shape.remove(); });
        this.controlPoints = [];
        this.drawState = {
            strokeStyle: '#000',
        };
        _super.prototype.unSelect.call(this);
        window.removeEventListener('keydown', this.ZKeyDown);
    };
    return ModifyAbleShape;
}(SelectAbleShape_1.SelectAbleShape));
exports.ModifyAbleShape = ModifyAbleShape;
//# sourceMappingURL=ModifyAbleShape.js.map